/*  ==========================================================================
    BUTTONS
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initButtons($element) {

    // magnific popup
    utils.mfp.initIframe($element);

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/buttons.js